import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-landscape-line',
      title: t('service1_title'),
      description: t('service1_desc'),
      points: [
        t('service1_point1'),
        t('service1_point2')
      ]
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: t('service2_title'),
      description: t('service2_desc'),
      points: [
        t('service2_point1'),
        t('service2_point2')
      ]
    },
    {
      icon: 'ri-file-chart-line',
      title: t('service3_title'),
      description: t('service3_desc'),
      points: [
        t('service3_point1'),
        t('service3_point2')
      ]
    },
    {
      icon: 'ri-search-eye-line',
      title: t('service4_title'),
      description: t('service4_desc'),
      points: [
        t('service4_point1'),
        t('service4_point2')
      ]
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('service5_title'),
      description: t('service5_desc'),
      points: [
        t('service5_point1'),
        t('service5_point2')
      ]
    },
    {
      icon: 'ri-map-2-line',
      title: t('service6_title'),
      description: t('service6_desc'),
      points: [
        t('service6_point1'),
        t('service6_point2')
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('services_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('services_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#1e3a8a] rounded-lg mb-6">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.points.map((point, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-700">
                    <i className="ri-check-line text-[#1e3a8a] mt-0.5 mr-2 flex-shrink-0"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
